import React from "react";
import TextField from "@mui/material/TextField";
import "./styles.scss";
import { InputAdornment } from "@mui/material";

type NumericFieldPropTypes = {
  label: string;
  testId?: string;
  val: string;
  // eslint-disable-next-line no-unused-vars
  setVal: (val: string) => void;
  inputAdorment?: string;
  placeholder?: string;
  decimalPlaces?: number;
  endsWith?: string;
  callback?: Function;
  [key: string]: any;
};

const NumericField = (props: NumericFieldPropTypes) => {
  const {
    label,
    testId,
    val,
    setVal,
    inputAdorment,
    placeholder,
    decimalPlaces,
    endsWith,
    callback,
    ...restProps
  } = props;

  const handleOnChange = (event: { target: { value: any } }) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^0-9.]/g, "");
    const parts = inputValue.split(".");
    if (parts.length > 1) {
      inputValue = `${parts[0] ? parts[0] : 0}.${parts[1].slice(
        0,
        decimalPlaces
      )}`;
    }
    if (endsWith) {
      if (!isNaN(inputValue)) {
        setVal(inputValue + "%");
      } else {
        setVal("0%");
      }
    } else {
      setVal(inputValue);
    }
    callback && callback(inputValue);
  };

  return (
    <TextField
      id="outlined-adornment-amount"
      className="amount-outlined-input"
      inputProps={{
        "data-testid": testId,
        inputMode: "numeric",
        pattern: "[0-9]*",
      }}
      InputProps={{
        startAdornment: inputAdorment && (
          <InputAdornment position="start">{inputAdorment}</InputAdornment>
        ),
      }}
      type="text"
      onChange={handleOnChange}
      value={val}
      placeholder={placeholder ?? "0.00"}
      autoComplete="off"
      label={label}
      variant="outlined"
      size="small"
      {...restProps}
    />
  );
};

export default NumericField;
